'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var ActionsLike = /*#__PURE__*/ forwardRef(function(props, ref) {
    return /*#__PURE__*/ jsx(SvgIcon, _extends({
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16"
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m5 5.971 1.96-1.46a12.3 12.3 0 0 0 2.108-2.719L9.88.37a.75.75 0 0 1 1.282-.02c.45.731.525 1.626.199 2.418l-.743 1.808c-.275.668.231 1.395.971 1.395l3.003-.001c.9 0 1.57.81 1.374 1.666l-1.002 4.385c-.264 1.155-1.318 1.978-2.535 1.978L5 14zM2 14a1 1 0 1 1 0-2 1 1 0 0 1 0 2M0 6v9h2.223C3.205 15 4 14.204 4 13.222V6z",
            clipRule: "evenodd"
        })
    }));
});

export { ActionsLike, ActionsLike as default };
